import type { LayoutKey } from '#build/types/layouts'
import type { UserRole } from '~/schemas/auth'

export function resolveLayout(currentRole: UserRole | null | undefined, routePath?: string, platformSubscriberContext?: number | null): LayoutKey {
  if (!currentRole) return 'default'

  // Platform users without subscriber context
  if (!currentRole.subscriber_id && !platformSubscriberContext) return 'platform'

  // Platform admin in subscriber context OR regular subscriber users
  return 'agency'
}
